/* eslint-disable import/no-unresolved */
/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable jsx-a11y/tabindex-no-positive */
/* eslint-disable react/no-array-index-key */
import {
    Breadcrumb, Panel, Table,
} from 'appkit-react';
import {
    Row, Col, Container,
} from 'react-bootstrap';

import Loader from 'views/Shared/components/Loader';
import ErrorView from 'views/Shared/components/ErrorView';
import { capitalizeFunc } from '../../../../utils';
import DetailChart from './DetailChart';
import '../styles/qualityDetail.scss';

const QualityDetails = ({
    breadcrumbItems, columnWiseDQScore, navigateBack, showDetailsTable,
    showTableLoader, dimensionDetailsLoading, rowsProcesed, dataQualityDetailsColumns,
    detailsTableData, selectedColumn, isRowDetailsError, isDimensionDetailsError,
    dimensions, selectedDimensionId, selectedColumnDimensionName, selectedColumnId,
    columnsList, onDimensionDropDownClose, onColumnDropDownClose, onColumnBarSelection,
}) => (
    <div className="true-comply-data-quality-detail_layout">
        <div className="true-comply-data-quality-detail_column-2">
            <Breadcrumb items={breadcrumbItems} />
            <div className="a-h3 title-label">
                <span className="appkiticon icon-left-chevron-outline left-arrow-icon" onClick={navigateBack} role="presentation" />
                Data Quality Details
            </div>
            {isDimensionDetailsError && <ErrorView />}
            {dimensionDetailsLoading && <Loader />}
            {!isDimensionDetailsError && !dimensionDetailsLoading && (
                <Container
                    fluid
                    className="true-comply-data-quality-detail_card_container"
                >
                    <Row
                        className="g-4"
                        style={{ paddingLeft: '1rem', paddingRight: '1rem', paddingTop: '0.5rem' }}
                    >
                        <Col>
                            <DetailChart
                                columnsList={columnsList}
                                columnWiseDQScore={columnWiseDQScore}
                                rowsProcesed={rowsProcesed}
                                selectedDimensionId={selectedDimensionId}
                                selectedColumnId={selectedColumnId}
                                dimensions={dimensions}
                                onDimensionDropDownClose={onDimensionDropDownClose}
                                onColumnDropDownClose={onColumnDropDownClose}
                                onColumnBarSelection={onColumnBarSelection}
                            />

                        </Col>
                    </Row>
                    {showDetailsTable && selectedColumnDimensionName && (
                        <Row
                            className="g-4 details-table"
                            style={{ paddingLeft: '1rem', paddingRight: '1rem', paddingTop: '0.5rem' }}
                        >
                            <Col>
                                <Panel
                                    title={`${capitalizeFunc(selectedColumnDimensionName)}- Failed Row details for "${selectedColumn}" column`}
                                    style={{ margin: '0.5rem' }}
                                >
                                    {isRowDetailsError && <ErrorView />}
                                    {showTableLoader && <Loader />}
                                    {!showTableLoader && (
                                        <Table
                                            data={detailsTableData}
                                            columns={dataQualityDetailsColumns}
                                            showPagination
                                            defaultPageSize={10}
                                            sortable
                                            resizable
                                            noDataText="No Failed Rows Found ..!!!"
                                        />
                                    )}
                                </Panel>
                            </Col>
                        </Row>
                    )}
                </Container>
            )}
        </div>
    </div>
);

export default QualityDetails;
